import { render, staticRenderFns } from "./authRole.vue?vue&type=template&id=37480d8b&scoped=true"
import script from "./authRole.vue?vue&type=script&lang=js"
export * from "./authRole.vue?vue&type=script&lang=js"
import style0 from "./authRole.vue?vue&type=style&index=0&id=37480d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37480d8b",
  null
  
)

export default component.exports